import { useTheme } from '@emotion/react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { ICellRendererParams } from 'ag-grid-community';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../common/Header/Header';
import {
  ButtonWrapper,
  Page,
  TableWrapper,
} from '../../common/TableWithButtonsAboveLayout/TableWithButtonsAboveLayout.styles';
import Button from '../../components/Button/Button';
import Table from '../../components/Table/Table';
import { IconWrapper } from '../../components/Table/Table.styles';
import { showToast } from '../../components/Toast/Toast';
import { ToastTypes } from '../../components/Toast/Toast.types';
import { useStores } from '../../services/storeControl/storeControl.service';
import { genericErrorShowToastOptions } from '../../utils/useGenericErrorMessage/useGenericErrorMessage';

const StoreControl: FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { data, isError, error } = useStores();

  useEffect(() => {
    if (error || isError) {
      showToast({
        ...genericErrorShowToastOptions,
        label: 'Error loading stores.',
        id: 'storeFetchError',
        toastType: ToastTypes.Error,
      });
    }
  }, [error, isError]);

  return (
    <>
      <Header breadcrumb={{ label: 'All tables', to: '/tables' }} title='Store Control' />
      <Page>
        <ButtonWrapper>
          <Button label='Add New' onClick={() => navigate(`/storecontrol/new`)} />
        </ButtonWrapper>
        <TableWrapper>
          <Table
            rowData={data?.data}
            columnDefs={[
              {
                headerName: 'Store No.',
                field: 'storeNo',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                flex: 1,
              },
              {
                headerName: 'Market',
                field: 'marketNo',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                flex: 1,
              },
              {
                headerName: 'Coupon Group ID',
                field: 'couponGroupId',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                flex: 1,
              },
              {
                headerName: 'Mandatory Inventory Group',
                field: 'maninvGroupId',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                flex: 1,
              },
              {
                headerName: 'Concept',
                field: 'conceptType',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                flex: 1,
              },
              {
                headerName: 'DMA',
                field: 'dma',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                flex: 1,
                resizable: false,
              },
              {
                headerName: 'Store Status',
                field: 'storeStatus',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                flex: 1,
                resizable: false,
              },
              {
                field: 'edit',
                pinned: 'right',
                resizable: false,
                lockPinned: true,
                sortable: false,
                width: 60,
                floatingFilter: false,
                cellRenderer: (params: ICellRendererParams) => {
                  const handleClick = () => {
                    navigate(`/storecontrol/${params.data.storeNo}`);
                  };
                  return (
                    <IconWrapper>
                      <EditOutlinedIcon htmlColor={theme.colors.blue} onClick={handleClick} />
                    </IconWrapper>
                  );
                },
              },
            ]}
            returnedRecords={data?.data.length || 0}
            height={'calc(100vh - 266px)'}
            width={'100%'}
          />
        </TableWrapper>
      </Page>
    </>
  );
};
export default StoreControl;
